// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const taillow: PokeData = {
  "id": 276,
  "name": "taillow",
  "height": 3,
  "weight": 23,
  "base_experience": 54,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "growl",
    "peck",
    "agility",
    "quick-attack",
    "double-team",
    "focus-energy",
    "reversal",
    "endeavor",
    "aerial-ace",
    "air-slash",
    "brave-bird",
    "quick-guard"
  ],
  "moves": [
    "growl",
    "peck",
    "agility",
    "quick-attack",
    "aerial-ace",
    "air-slash",
    "brave-bird",
    "supersonic",
    "tackle",
    "sky-attack",
    "splash",
    "refresh",
    "acrobatics"
  ],
  "evolution_chain": {
    "id": 138,
    "item": null,
    "species": [
      {
        "name": "taillow",
        "order": 301,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swellow",
        "order": 302,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 276,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 35,
    "speed": 85,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
